/*
         * @ngdoc function
         * @name ePay.Model:Session_AppleHeaderModel
         * @description
         * Model
         */

export class Session_AppleHeaderModel {
  ephemeralPublicKey: string | null | undefined;
  publicKeyHash: string | null | undefined;
  transactionId: string | null | undefined;

	constructor(
		ephemeralPublicKey?: string, 
		publicKeyHash?: string, 
		transactionId?: string
	) {
		this.ephemeralPublicKey = ephemeralPublicKey || null;
		this.publicKeyHash = publicKeyHash || null;
		this.transactionId = transactionId || null;
	}
}
